module.exports = __webpack_public_path__ + "images/Quilty_Black_and_Blue_on_Transparent_Web.png";